jQuery(document).ready(function ($) {

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//BALAO DO WHATS
	$('a.whats').click(function(e) {
		closeWhatsBallon();
	});

	$('.whats-balao').hover(function(e) {
		closeWhatsBallon();
	});

	function closeWhatsBallon() {
		$('.whats-balao').remove();
	}

	setTimeout( function() { closeWhatsBallon(); }, 10000);

	//GALERIA
	$('.galeria-page a, a.galeria-campo, a.fotos-capa').magnificPopup({
		type: 'image',
		gallery:{
			enabled:true,
			tPrev: 'Anterior',
			tNext: 'Próxima',
			tCounter: '%curr% de %total%'
		}
	});

  //UNIDADES ESTADOS
  $('.pagina-unidades a.dropdown-item').click(function(e) {
    e.preventDefault();
    const cidade = $(this).data('cidade');
    const cidade_nome = $(this).data('nome');

    $('.pagina-contato .dropdown-toggle').text(cidade_nome);

    if(cidade == 'all') {
      $('.pagina-unidades .con-cidade').removeClass('d-none');
    } else {
      $('.pagina-unidades .con-cidade').each(function(item) {
        if(this.classList.contains(cidade)) {
          this.classList.remove('d-none');
        } else {
          this.classList.add('d-none');
        }
      })
    }

  });

	//CARROSSEIS
	$('.hero-carrosel').owlCarousel({
		loop:true,
		margin:0,
		autoplay:true,
		autoplayTimeout:3000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:false,
		items:1
	});

	$('.destaques-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

	$('.fotos-carrosel').owlCarousel({
		loop:true,
		margin:15,
		autoplay:true,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:2
			},
			600:{
				items:3
			},
			1000:{
				items:5
			}
		}
	});

	$('.valores-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:true,
		autoplayTimeout:9000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			750:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

	$('.parceiros-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:6000,
		dots:true,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:false,
		autoHeight: false,
		responsive:{
			0:{
				items:2
			},
			600:{
				items:3
			},
			1000:{
				items:5
			}
		}
	});

	$('.cotacoes-carrosel').owlCarousel({
		loop:true,
		margin:0,
		autoplay:true,
		autoplayTimeout:6000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:false,
		autoHeight: false,
		items: 1
	});

	$('.noticias-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:6000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:3
			},
			1000:{
				items:4
			}
		}
	});

	$('.depoimentos-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:1
			},
			1000:{
				items:2
			}
		}
	});

	//FIX HEADER
	window.onscroll = function() { fixHeader() };
	function fixHeader() {
		if (window.pageYOffset > 70) {
			$('#topo').addClass('scrooled');
		} else {
			$('#topo').removeClass('scrooled');
		}
	}

	$('a.sem-link').click(function(e) {
		e.preventDefault();
	});

});